import React from "react";

const HalfTicket = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M16.4 32.444c0-.628-.253-1.231-.703-1.676A2.416 2.416 0 0 0 14 30.074c-.636 0-1.247.25-1.697.694a2.356 2.356 0 0 0-.703 1.676h-8a1.61 1.61 0 0 1-1.131-.462A1.57 1.57 0 0 1 2 30.864V5.58c0-.419.169-.82.469-1.117A1.61 1.61 0 0 1 3.6 4h8c0 .629.253 1.232.703 1.676.45.445 1.06.694 1.697.694.636 0 1.247-.25 1.697-.694.45-.444.703-1.047.703-1.676h16c.424 0 .831.166 1.131.463.3.296.469.698.469 1.117v8.692c-1.06 0-2.078.416-2.828 1.157A3.926 3.926 0 0 0 30 18.222c0 1.048.421 2.053 1.172 2.794A4.025 4.025 0 0 0 34 22.173v8.691c0 .42-.169.821-.469 1.118a1.61 1.61 0 0 1-1.131.462h-16ZM14 15.852c.636 0 1.247-.25 1.697-.694.45-.445.703-1.048.703-1.676 0-.63-.253-1.232-.703-1.677A2.415 2.415 0 0 0 14 11.111c-.636 0-1.247.25-1.697.694a2.356 2.356 0 0 0-.703 1.677c0 .628.253 1.231.703 1.676.45.444 1.06.694 1.697.694Zm0 9.481c.636 0 1.247-.25 1.697-.694.45-.444.703-1.047.703-1.676s-.253-1.232-.703-1.676A2.415 2.415 0 0 0 14 20.593c-.636 0-1.247.25-1.697.694a2.356 2.356 0 0 0-.703 1.676c0 .629.253 1.232.703 1.676.45.445 1.06.694 1.697.694Z"
            fill={fill}
        />
    </svg>
);

export default HalfTicket;
